import React from 'react'
import { configure } from 'mobx'
import { RouterProvider } from 'react-router-dom'
import { App as AntdApp } from 'antd'
import { routerConfig } from '@/router/routers'
import useSubScribeLoginExpire from '@/hooks/use-subscribe-login-expire'
import { useAppCheckVersionUpdate } from '@/components/check-app-version'
import { useSocket } from '@/socket'
import { getToken } from '@/utils/user'
import I18nProvider from '@/i18n/provider'
import '@/styles/global.scss'

configure({
  isolateGlobalState: true,
  enforceActions: 'never'
})

/** 须在 AntdApp 子树内调用 useApp，否则 message.error 不可用 */
const AntdToastBridge: React.FC = ({ children }) => {
  const win = window as Window & { antd_toast?: (text: string, opt?: { type: string }) => void }
  const { message } = AntdApp.useApp()

  win.antd_toast = (text: string, opt?: { type: string }) => {
    if (opt?.type) {
      message[opt.type as 'error']?.(text)
      return
    }
    message?.error?.(text)
  }

  return <>{children}</>
}

const MainProvider: React.FC = ({ children }) => {
  return (
    <AntdApp>
      <AntdToastBridge>{children}</AntdToastBridge>
    </AntdApp>
  )
}

const env = import.meta.env.MODE

function App() {
  useSocket()
  useSubScribeLoginExpire()

  useAppCheckVersionUpdate({
    env: env as 'test' | 'prod',
    key: getToken(),
    project: 'aigc-web',
    runtimeEnv: import.meta.env.VITE_NODE_ENV as 'dev' | 'prod'
  })

  return (
    <React.Suspense fallback="">
      <I18nProvider>
        <MainProvider>
          <RouterProvider router={routerConfig} />
        </MainProvider>
      </I18nProvider>
    </React.Suspense>
  )
}

export default App
